import _ from "lodash";
import React from "react";
import { connect } from "react-redux";

import MemberList from "./MemberList";
import SelectedMember from "./SelectedMember";
import LogoImage from "../../assets/images/clinic_logo.png";
import MemberRemoveDeviceConfirmModal from "./MemberRemoveDeviceConfirmModal";

import {
  adminLogin,
  chooseMember,
  deleteDeviceConfirmModalShow,
  forgotPassword,
  initMemberLogin,
  login,
  branchChangeRequested,
  setAuthTokenState,
} from "../../actions/authActions";
import { getOnlyBtsColors } from "../../actions/appointmentActions";
import { withRouter } from "react-router";
import { Routes } from "../../constants/Routes";
import BackGroundImage from "../../assets/images/clinic_bg_image.jpg";
import FormBackGroundImage from "../../assets/images/clinic_bg.png";
import { obtainImagePath } from "../../utils/ImageUtils";
import ReCaptcha from "../ui/ReCaptcha";
import { recaptchaSiteKey } from "../../constants/Constants";
import Utils from "../../helpers/Utils";

const enhancer = connect(
  ({
    session: { clinic },
    auth: {
      members,
      baseUrl,
      chosenMemberId,
      deleteDeviceConfirmVisible,
      user,
      deviceExist,
      showAuthCaptcha,
      authCaptchaError,
    },
  }) => {
    return {
      clinic,
      members,
      chosenMemberId,
      deleteDeviceConfirmVisible,
      baseUrl,
      user,
      deviceExist,
      showAuthCaptcha,
      authCaptchaError,
    };
  },
  {
    initMemberLogin,
    login,
    chooseMember,
    forgotPassword,
    deleteDeviceConfirmModalShow,
    adminLogin,
    getOnlyBtsColors,
    branchChangeRequested,
    setAuthTokenState,
  },
);
export default withRouter(
  enhancer(
    class MemberLogin extends React.Component {
      constructor(props) {
        super(props);

        this.state = {
          filter: "",
          recaptchaRef: React.createRef(),
          recaptchaToken: null,
          members: props.members,
        };
      }

      handleSubmit = (event) => {
        event.preventDefault();

        if (this.props.showAuthCaptcha && !this.state.recaptchaToken) return;

        this.props
          .login(event.target.password.value, this.state.recaptchaToken)
          .then((response) => {
            this.props.getOnlyBtsColors();

            if (response && response.date) {
              const {
                members,
                chosenMemberId,
                history: { push },
              } = this.props;
              if (members[chosenMemberId].status.name === "Idle") {
                push(Routes.DashboardProfile);
              } else {
                push(Routes.Dashboard);
              }
            }
          });
      };

      componentDidMount() {
        Utils.clearFavourites();
        if (this.props.deviceExist) this.props.initMemberLogin();
      }

      componentDidUpdate(prevProps, prevState) {
        const { members: prevMembers } = prevProps;
        const { members: nextMembers } = this.props;
        const { filter: prevFilter } = prevState;
        const { filter: nextFilter } = this.state;

        if (prevFilter !== nextFilter || !_.isEqual(prevMembers, nextMembers)) {
          const memberList = Object.values(nextMembers);

          const newMembers = memberList
            .filter(({ firstName, lastName }) => {
              return (
                nextFilter === "" ||
                [_.toLower(firstName), _.toLower(lastName)]
                  .join(" ")
                  .indexOf(_.toLower(nextFilter)) >= 0
              );
            })
            .reduce(
              (acc, item) => ({
                ...acc,
                [item.id]: item,
              }),
              {},
            );

          this.setState({ members: newMembers });
        }
      }

      forgotPassword = (event) => {
        event.preventDefault();

        this.props.forgotPassword();
      };

      chooseMember = (id) => {
        this.refs.password.focus();

        this.props.chooseMember(id);
      };

      handleRecaptcha = (token) => {
        this.setState({ recaptchaToken: token });
        this.props.setAuthTokenState(false);
      };

      render() {
        const { filter, members } = this.state;

        return (
          <div
            className="member-login-page"
            style={{
              backgroundImage: `url(${obtainImagePath(BackGroundImage)})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "bottom",
            }}
          >
            <div className="left-side">
              <div className="title">
                <div className="logo">
                  <img src={LogoImage} alt="" />
                </div>
                <div className="clinic-name">{this.props.clinic && this.props.clinic.name}</div>
              </div>
              <input
                style={{ maxWidth: "414px" }}
                value={filter}
                placeholder="Filter by name"
                className="form-control login-members-filter mb-1"
                onChange={({ target }) => this.setState({ filter: target.value })}
              />
              <MemberList members={members} chooseMember={this.chooseMember} />
              <div className="row">
                <div className="col-sm-2" />
                <div className="col-sm-8">
                  <button
                    type="button"
                    className="btn btn-primary member-log-out mt-1"
                    onClick={this.props.deleteDeviceConfirmModalShow}
                  >
                    Remove Device
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary member-log-out mt-1"
                    onClick={() => {
                      this.props.branchChangeRequested(true);
                      this.props.history.push(Routes.AuthChooseClinic);
                    }}
                  >
                    Change Branch
                  </button>
                </div>
                <div className="col-sm-2" />
              </div>
            </div>
            <div className="right-side">
              <form
                onSubmit={this.handleSubmit}
                style={{ backgroundImage: `url(${FormBackGroundImage})` }}
              >
                <SelectedMember member={members[this.props.chosenMemberId]} />
                <div className="password">
                  <input
                    className="form-control input-lg"
                    type="password"
                    name="password"
                    ref="password"
                    placeholder="Password"
                  />
                </div>
                <div className="privacy-policy">
                  By signing in, you acknowledge that this system contains confidential medical
                  information. Unauthorized access is prohibited and may be subject to legal action.
                  All activities are monitored and logged.
                </div>
                <div className="forgot">
                  <a href="#" onClick={this.forgotPassword}>
                    Forgot password?
                  </a>
                </div>
                {this.props.showAuthCaptcha ? (
                  <div className="w-100 d-flex flex-column align-items-center">
                    <span className="captcha-error">{this.props.authCaptchaError}</span>
                    <ReCaptcha
                      ref={this.state.recaptchaRef}
                      sitekey={recaptchaSiteKey}
                      onChange={this.handleRecaptcha}
                    />
                  </div>
                ) : (
                  <div className="sign-in-button">
                    <button type="submit" className="btn btn-lg btn-block btn-success">
                      Sign In
                    </button>
                  </div>
                )}
              </form>
            </div>
            <MemberRemoveDeviceConfirmModal show={this.props.deleteDeviceConfirmVisible} />
          </div>
        );
      }
    },
  ),
);
